import { ASSET_APP_IDS } from "@zapier/canvas-constants";
import { AssetType } from "../types";

/**
 * Asset type excluding "zap" since app IDs don't determine zap nodes.
 */
export type NonZapAssetType = Exclude<AssetType, "zap">;

/**
 * Determines the asset type from an app ID.
 *
 * @param appId - The app ID to check (e.g., from currentImplementation.id)
 * @returns The asset type ("table", "interface", "chatbot", "agent") or undefined if not an asset app
 */
export function getAssetTypeFromAppId(appId: string): NonZapAssetType {
  if (appId.includes(ASSET_APP_IDS.TABLES)) {
    return "table";
  }
  if (appId.includes(ASSET_APP_IDS.INTERFACES)) {
    return "interface";
  }
  if (appId.includes(ASSET_APP_IDS.CHATBOTS)) {
    return "chatbot";
  }
  if (appId.includes(ASSET_APP_IDS.AGENTS)) {
    return "agent";
  }
  return undefined;
}
